import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import Error from "./Pages/Error";
import UnderMaintenance from "./Pages/UnderMaintenance";
import OtpVarification from "./Pages/OtpVarification";
import MyProfile from "./Pages/MyProfile";
import UserVerification from "./Pages/UserVerification";
import AddNewChatboot from "./Pages/AddNewChatboot";
import { ToastContainer } from "react-toastify";
import Loader from "./Components/Loader";
import PrivateRoute from "./routes/PrivateRoute";
import Bots from "./Pages/bots";
import Admins from "./Pages/Admins";
import AddNewUser from "./Pages/AddNewUser";
import Feedback from "./Pages/Feedback";
import FAQs from "./Pages/FAQs";
import AddNewFaq from "./Pages/AddNewFaq";
import Dashboard from "./Pages/dashboard";
import Prompts from "./Pages/prompts";
import AddPrompt from "./Pages/add-prompt";
import Source from "./Pages/source";
function App() {
  return (
    <div className="App">
      <ToastContainer
        limit={1}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Loader />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/forgot-password" element={<ForgotPassword />}></Route>
          <Route path="/reset-password/:token" element={<ResetPassword />}></Route>
          <Route path="/error" element={<Error />}></Route>
          <Route
            path="/under-maintenance"
            element={<UnderMaintenance />}
          ></Route>
          <Route path="/otp-varification" element={<OtpVarification />}></Route>
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Dashboard />}></Route>
            <Route path="/chatbots" element={<Bots />}></Route>
            <Route path="/my-profile" element={<MyProfile />}></Route>
            <Route path="/admin" element={<Admins />}></Route>
            <Route path="/add-new-admin" element={<AddNewUser />}></Route>
            <Route path="/feedback" element={<Feedback />}></Route>
            <Route path="/prompts" element={<Prompts />}></Route>
            <Route path="/add-prompt" element={<AddPrompt />}></Route>
            <Route path="/faqs" element={<FAQs />}></Route>
            <Route path="/add-new-faq" element={<AddNewFaq />}></Route>
            <Route path="/resource" element={<Source />}></Route>
            <Route
              path="/user-verification"
              element={<UserVerification />}
            ></Route>
            <Route path="/add-new-chatbot" element={<AddNewChatboot />}></Route>
          </Route >

        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
